var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFulfillmentRequested = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16.9 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 7h13.001v3.051h-1V9H8v12.999h11.001V20h1v3H7zm10.244 5H23.9v6.656h-1.999v-3.242l-4.485 4.485L16 18.485 20.487 14h-3.243zM9 12v-1h5v1zm0 4v-1h5v1zm0 4v-1h5v1z"
})));
export default SvgFulfillmentRequested;